import React from 'react';
import loadable from '@loadable/component';
import Loading from '../components/Loading/Loading';

import Banner from '../components/Banner/Banner';
import Clinets from '../components/Clients/Clinets';
// import Services from '../components/Services/Services';
import Testmonial from '../components/Testimonial/Testmonial';
import Why from '../components/WhySection/Why';

const Layout = loadable(() => import('../components/Layout/Layout'), {
  fallback: <Loading />,
});
const Services = loadable(() => import('../components/Services/Services'), {
  fallback: <Loading />,
});
/* 
const Banner = loadable(() => import('../components/Banner/Banner'), {
  fallback: <Loading />,
});
const Clinets = loadable(() => import('../components/Clients/Clinets'), {
  fallback: <Loading />,
});

const Testmonial = loadable(
  () => import('../components/Testimonial/Testmonial'),
  {
    fallback: <Loading />,
  }
);
const Why = loadable(() => import('../components/WhySection/Why'), {
  fallback: <Loading />,
}); 

*/

const index = () => {
  return (
    <Layout>
      <Banner />

      <Services />
      <Why />
      <Clinets />
      <Testmonial />
    </Layout>
  );
};

export default index;
